// extracted by mini-css-extract-plugin
export default {"Modal":"FullScreenWrapper_Modal__IkblS"};